import React from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '../ui/dialog';
import { CheckSquare } from 'lucide-react';

const BulkPaymentDialog = ({
  bulkPayDialog, setBulkPayDialog,
  bulkPayDate, setBulkPayDate,
  bulkPayNotes, setBulkPayNotes,
  confirmBulkPaid,
  selectedBillsSize,
}) => {
  return (
    <Dialog open={bulkPayDialog} onOpenChange={v => { if (!v) setBulkPayDialog(false); }}>
      <DialogContent className="max-w-sm z-50">
        <DialogHeader><DialogTitle>Bulk Mark as Paid</DialogTitle><DialogDescription>{selectedBillsSize} bill(s) will be marked as paid</DialogDescription></DialogHeader>
        <div className="space-y-4 pt-2">
          <div><Label>Payment Date</Label><Input type="date" value={bulkPayDate} onChange={e => setBulkPayDate(e.target.value)} data-testid="bulk-payment-date-input" /></div>
          <div><Label>Notes (optional)</Label><Input value={bulkPayNotes} onChange={e => setBulkPayNotes(e.target.value)} placeholder="e.g. Bank transfer, Cheque #..." data-testid="bulk-payment-notes-input" /></div>
          <div className="flex gap-2 justify-end">
            <Button variant="outline" onClick={() => setBulkPayDialog(false)}>Cancel</Button>
            <Button className="bg-green-600 hover:bg-green-700 gap-1" onClick={confirmBulkPaid} data-testid="confirm-bulk-paid-btn"><CheckSquare className="w-4 h-4" /> Confirm Payment</Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default BulkPaymentDialog;
